exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".results_form[data-v-7e535306]{max-width:600px!important}", ""]);

// exports
